// Shared Style Utilities
export const commonStyles = {
  card: {
    borderRadius: 3,
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: 4,
    },
  },

  gradientBackground: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },

  centerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  responsiveContainer: (theme) => ({
    maxWidth: 520,
    mx: 'auto',
    px: { xs: 2, sm: 3 },
    [theme.breakpoints.down('sm')]: {
      px: 1.5,
    },
  }),

  flexBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  glass: {
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
};

export const animations = {
  fadeIn: {
    '@keyframes fadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    animation: 'fadeIn 0.3s ease-in',
  },

  slideUp: {
    '@keyframes slideUp': {
      from: { transform: 'translateY(20px)', opacity: 0 },
      to: { transform: 'translateY(0)', opacity: 1 },
    },
    animation: 'slideUp 0.4s ease-out',
  },

  pulse: {
    '@keyframes pulse': {
      '0%, 100%': { transform: 'scale(1)' },
      '50%': { transform: 'scale(1.05)' },
    },
    animation: 'pulse 2s infinite',
  },
};

export const shadows = {
  card: '0 2px 8px rgba(0, 0, 0, 0.1)',
  elevated: '0 4px 20px rgba(0, 0, 0, 0.15)',
  modal: '0 8px 32px rgba(0, 0, 0, 0.2)',
};

export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};
